exports.default = {
  'ask_ai': 'Ask AI',
  'background_color': 'Background color',
  'reset_to_default': 'Reset to default',
  'black': 'Black',
  'gray': 'Gray',
  'red': 'Red',
  'orange': 'Orange',
  'yellow': 'Yellow',
  'green': 'Green',
  'blue': 'Blue',
  'purple': 'Purple',
  'transparent': 'Transparent',
  'light_gray': 'Light gray',
  'light_red': 'Light red',
  'light_orange': 'Light orange',
  'light_yellow': 'Light yellow',
  'light_green': 'Light green',
  'light_blue': 'Light blue',
  'light_purple': 'Light purple',
  'middle_gray': 'Medium gray',
  'middle_red': 'Medium red',
  'middle_orange': 'Medium orange',
  'middle_yellow': 'Medium yellow',
  'middle_green': 'Medium green',
  'middle_blue': 'Medium blue',
  'middle_purple': 'Medium purple',
  'center_align': 'Center align',
  'font_color': 'Font color',
  'border_color': 'Border color',
  'body_text': 'Body text',
  'heading_1': 'Heading 1',
  'heading_2': 'Heading 2',
  'heading_3': 'Heading 3',
  'heading_4': 'Heading 4',
  'heading_5': 'Heading 5',
  'heading_6': 'Heading 6',
  'heading_7': 'Heading 7',
  'heading_8': 'Heading 8',
  'heading_9': 'Heading 9',
  'numbered_list': 'Numbered list',
  'bullet_list': 'Bullet list',
  'task_list': 'Task list',
  'table': 'Table',
  'image': 'Image',
  'video': 'Video',
  'audio': 'Audio',
  'attachment': 'Attachment',
  'emoji': 'Emoji',
  'code_block': 'Code block',
  'quote_block': 'Quote block',
  'highlight_block': 'Highlight block',
  'dividing_line': 'Dividing line',
  'link': 'Link',
  'alignment': 'Alignment',
  'color': 'Color',
  'cut': 'Cut',
  'copy': 'Copy',
  'copy_success': 'Copy successful',
  'delete': 'Delete',
  'space': 'Space',
  'today_thoughts_enter': 'What are your thoughts today? Start typing to see and get AI help!',
  'continue_input_regenerate': 'Continue input, regenerate',
  'thinking': 'Thinking',
  'editing': 'Editing',
  'abort_ai_editing': 'Do you want to abort AI editing?',
  'ai_editing_timeout': 'AI editing timed out! Do you want to keep or discard AI edits?',
  'keep_or_abort_ai_editing': 'Do you want to keep or abort AI editing?',
  'ai_editing_error_end_waiting': 'AI editing error! End waiting?',
  'keep': 'Keep',
  'abort': 'Abort',
  'end': 'End',
  'give_up': 'Give up',
  'cancel': 'Cancel',
  'executing': 'Executing',
  'accept': 'Accept',
  'insert_below': 'Insert below',
  'overwrite_original': 'Overwrite original',
  'try_again': 'Try again',
  'basics': 'Basics',
  'others': 'Others',
  'markdown_format_space': 'Markdown: # space',
  'markdown_format_h2_space': 'Markdown: ## space',
  'markdown_format_h3_space': 'Markdown: ### space',
  'markdown_format_h4_space': 'Markdown: #### space',
  'markdown_format_h5_space': 'Markdown: ##### space',
  'markdown_format_h6_space': 'Markdown: ###### space',
  'markdown_format_h7_space': 'Markdown: ####### space',
  'markdown_format_h8_space': 'Markdown: ######## space',
  'markdown_format_h9_space': 'Markdown: ######### space',
  'markdown_format_numbered_list': 'Markdown: 1. space',
  'markdown_format_bullet_list': 'Markdown: - space',
  'markdown_format_check_list': 'Markdown: [] space',
  'markdown_format_code_block': 'Markdown: ``` space',
  'markdown_format_block_quote': 'Markdown: > space',
  'markdown_format_horizontal_rule': 'Markdown: ---',
  'upload_image_size_cannot_exceed_10m': 'Upload image size cannot exceed 10MB!',
  'upload_file_size_cannot_exceed_20m': 'Upload file size cannot exceed 20MB!',
  'default_placeholder': 'Press space to activate AI assistant, enter / to use shortcuts',
  'insert_code_block': 'Insert code block',
  'insert_a_code_block': 'Insert a code block',
  'block_quote': 'Block quote',
  'insert_a_block_quote': 'Insert a block quote',
  'insert_dividing_line': 'Insert dividing line',
  'insert_highlight_block': 'Insert highlight block',
  'insert_image': 'Insert image',
  'insert_video': 'Insert video',
  'insert_file': 'Insert file',
  'insert_table': 'Insert table',
  'mermaid': 'Insert mermaid',
  'latex': 'Insert latex',
  'insert_link': 'Insert link',
  'insert_a_link': 'Insert a link',
  'title': 'Title',
  'used_for_subsection_and_group_titles': 'Used for subsection and group titles',
  'left_align': 'Left align',
  'right_align': 'Right align',
  'text_align': 'Text align',
  'hello_what_can_i_do_for_you_today': 'What can I do for you today?',
  'what_web_page_do_u_want': 'What kind of webpage do you want to create today?',
  'create_website': 'Create your exclusive website',
  'talk_to_ai': 'Talk to the AI assistant and describe your needs and ideas,',
  'tailored_design': 'We will tailor professional website design for you.',
  'ask_them': 'Ask them',
  'your_agents': 'Your agents',
  'chat': 'Chat',
  'new_conversation': 'New conversation',
  'history': 'History',
  'close': 'Close',
  'intelligent_assistant_pai': 'Intelligent Assistant PAI',
  'quick_start': 'Quick start',
  'upload_image': 'Upload image',
  'upload_image_cannot_exceed_10m': 'Upload image size cannot exceed 10MB!',
  'upload_file_cannot_exceed_20m': 'Upload file size cannot exceed 20MB!',
  'file_type_error': 'File type error!',
  'network_error_send_failed': 'Network error, sending failed.',
  'error_please_try_again_later': 'Error occurred, please try again later!',
  'answer_timeout_please_try_again_later': 'Answer timeout, please try again later!',
  'message_contains_inappropriate_content': 'Your message contains inappropriate content, please check and resend!',
  'message_revoked_due_to_safety_compliance': 'Due to safety compliance restrictions, this message has been revoked.',
  'continue_before_number': 'Previous Number',
  'start_new_list': 'Start New List',
  'edit_number': 'Modify Number Value',
  'new_number_value_is': 'New Number Value is',
  'continue_number': 'Continue title numbering',
  'confirm': 'Confirm',
  'afresh_number': 'Restart numbering',
  'set_new_number': 'Set title numbering',
  'from': 'from',
  'start': 'Start',
  'current_number_value_is': 'Current number value is',
  'show_code_and_charts': 'Show code and charts',
  'only_show_code': 'Only show code',
  'only_show_charts': 'Only show charts',
  'view': 'View',
  'mermaid_error_message': 'Enter the code to display the chart',
  'original_size': 'Original Size',
  'fit_to_screen': 'Fit To Screen',
  'zoom_in': 'Zoom In',
  'zoom_out': 'Zoom Out',
  'rotate_left': 'Rotate Left',
  'rotate_right': 'Rotate Right',
  'download_image': 'Download'
}
